//region :: Imports ::
import {ICustomProperties, SeverityLevel} from '@microsoft/applicationinsights-web';
import {getAppInsights} from './AppInsights';
import ILogger from './ILogger';
import {toErrorMessage} from '../../Utils';

//endregion

/** */
class AppInsightsLogger implements ILogger {

    /** */
    public trackInfo(message: string, properties?: ICustomProperties): void {

        getAppInsights()!.trackTrace({
            message: message,
            severityLevel: SeverityLevel.Information
        }, properties);

    }

    /** */
    public trackWarning(message: string, properties?: ICustomProperties): void {

        getAppInsights()!.trackTrace({
            message: message,
            severityLevel: SeverityLevel.Warning
        }, properties);

    }

    /** */
    public trackError(error: Error, properties?: ICustomProperties): void {

        getAppInsights()!.trackException({
            exception: {...error, message: toErrorMessage(error)},
            severityLevel: SeverityLevel.Error
        }, properties);

    }

}

export default AppInsightsLogger;
